import { configureStore } from '@reduxjs/toolkit'
import creativesReducer from './creativesSlice'
import { setupListeners } from '@reduxjs/toolkit/query'
import { api } from '../services/api'

export const store = configureStore({
    reducer: {
        creativesState: creativesReducer,
        [api.reducerPath]: api.reducer,
    },

    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware().concat(api.middleware) // Api middleware enables caching, invalidation and polling for rtk-query
    },
})

setupListeners(store.dispatch) // Required for refetchOnFocus/refetchOnReconnect behaviors
